// extracted by mini-css-extract-plugin
module.exports = {"banner-indicator":"banner-swiper_banner-indicator__VnIW5"};